var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"print"}}),_c('div',{attrs:{"id":"web"}},[_c('router-view'),_c('CookiesBanner'),(_vm.isAppLoading)?_c('Loading'):_vm._e(),(_vm.isEdcProcessing)?_c('LoadingEdc',{ref:"loadingEdc",attrs:{"timeoutMinutes":_vm.edcTimeoutMinutes}}):_vm._e(),_c('Dialog',{ref:"Alert"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }